import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './App.css'
import { ThemeProvider } from './contexts/ThemeContext'

const Login = lazy(() => import('./Login'))
const Shop = lazy(() => import('./Shop'))
const SignUp = lazy(() => import('./SignUp'))
const ForgotPassword = lazy(() => import('./ForgotPassword'))
const NoPage = lazy(() => import('./NoPage'))
const ActiveProxies = lazy(() => import('./ActiveProxies'))
const History = lazy(() => import('./History'))
const Payments = lazy(() => import('./Payments'))
const Tickets = lazy(() => import('./Tickets'))
const ChangePassword = lazy(() => import('./ChangePassword'))
const Admin = lazy(() => import('./admin/Admin'))
const PaymentSuccess = lazy(() => import('./PaymentSuccess'))
const PaymentError = lazy(() => import('./PaymentError'))

const RouteFallback = () => (
  <div style={{
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--gradient-hero, #f5f5f5)'
  }}>
    <div style={{
      width: 32,
      height: 32,
      border: '2px solid var(--light-gray, #ddd)',
      borderTop: '2px solid var(--primary-orange, #ff6b35)',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }} />
  </div>
)

function App(props) {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<SignUp />} />
            <Route path="passwdrecovery" element={<ForgotPassword />} />
            <Route path="admin" element={<Admin apiClient={props.apiClient} />} />
            <Route path="account" element={<ChangePassword user={props.userData} active={props.active} apiClient={props.apiClient}/>} />
            <Route path="proxies" element={<Shop user={props.userData} active={props.active} apiClient={props.apiClient} setReloadData={props.setReloadData} setReloadActive={props.setReloadActive}/>}/>
            <Route path="active" element={<ActiveProxies user={props.userData} active={props.active} apiClient={props.apiClient} setReloadActive={props.setReloadActive}/>}/>
            <Route path="history" element={<History user={props.userData} active={props.active} apiClient={props.apiClient}/>}/>
            <Route path="transactions" element={<Payments user={props.userData} active={props.active} apiClient={props.apiClient}/>}/>
            <Route path="tickets" element={<Tickets user={props.userData} active={props.active} apiClient={props.apiClient}/>}/>
            <Route path="paymentsuccess" element={<PaymentSuccess />} />
            <Route path="paymenterror" element={<PaymentError />} />
            <Route path="*" element={<NoPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
